import storage from 'store'
import { useStore } from 'vuex'

export default function () {
  const store = useStore()

  store.dispatch('setLang', storage.get('languag') === 'en' ? 'en-US' : 'zh-CN')
}
